import Vue from 'vue';
import Vuex from 'vuex';
import stages from './stages';

Vue.use( Vuex );

export default new Vuex.Store( {
	state: {
		ready: false,
		loading: true,
		bootstrap: {
			proposalsLoaded: null,
		},
		proposals: null,
	},
	mutations: {

		setProposalsLoaded( state ){
			state.bootstrap = {
				...state.bootstrap,
				proposalsLoaded: true,
			};
		},

		setProposals( state, proposals ) {
			state.proposals = proposals;
		},

		setReady( state ){
			state.ready = true;
		},

		setLoading( state ){
			state.loading = true;
		},

		clearLoading( state ){
			state.loading = false;
		},

	},
	actions: {
	},
	modules: {
		stages,
	},
} );
